import {Dispatch} from "redux";
import IUser from "./IUser";
import {Alert} from "react-native";
export function  saveUser(user:IUser | undefined){
    return (dispatch: Dispatch) => {

        return dispatch({
            type: 'SAVE_USER',
            user
        });
    };
}
